export default {
  departments: [],
  cities: [],
  coverageCities: [],
};
